export default __webpack_public_path__ + "static/media/logo6 white animated.a925db7e.svg";